import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivateGuard implements CanActivate {

  constructor(private router: Router,
              private auth: AuthService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.auth.isAuthenticated()) {
      const { rol } = JSON.parse(localStorage.getItem('usuario'));
      if (rol === 'admin' || rol === 'basico') {
        return true;
      } else {
        //this.router.navigate(['/home']);
        return false;
      }
    } else {
      this.router.navigate(['/login']);
    }


  }

}
